// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1Xbmc","savePackageButton":"ClientWallet_savePackageButton__9hJaK"};